var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphicCloudStormDark255(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 255,
    viewBox: "0 0 255 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_795_1493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.5 212.495C174.441 212.495 212.495 174.441 212.495 127.5C212.495 80.5588 174.441 42.5053 127.5 42.5053C80.5588 42.5053 42.5054 80.5588 42.5054 127.5C42.5054 174.441 80.5588 212.495 127.5 212.495Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.812,
    cy: 84.4688,
    r: 37.25,
    fill: "#292929",
    stroke: "#737373",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.094 183.345C139.753 183.345 141.908 181.19 141.908 178.532C141.908 175.874 139.753 173.719 137.094 173.719C134.436 173.719 132.281 175.874 132.281 178.532C132.281 181.19 134.436 183.345 137.094 183.345Z",
    fill: "#0078D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9319 36.0825C48.414 36.0825 50.4262 34.0703 50.4262 31.5881C50.4262 29.1059 48.414 27.0938 45.9319 27.0938C43.4497 27.0938 41.4375 29.1059 41.4375 31.5881C41.4375 34.0703 43.4497 36.0825 45.9319 36.0825Z",
    stroke: "#737373",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.551 125.906L172.555 134.369H162.562L167.567 125.906H167.551Z",
    stroke: "#737373",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.468 194.593L219.584 203.247C219.712 203.454 219.552 203.725 219.313 203.725H209.097C208.858 203.725 208.699 203.454 208.826 203.247L213.942 194.593C214.07 194.386 214.373 194.386 214.484 194.593H214.468Z",
    fill: "#0078D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.087 68.7544H135.676V65.3438C135.676 64.4672 134.959 63.75 134.082 63.75C133.206 63.75 132.488 64.4672 132.488 65.3438V68.7544H129.094C128.217 68.7544 127.5 69.4716 127.5 70.3481C127.5 71.2247 128.217 71.9419 129.094 71.9419H132.504V75.3525C132.504 76.2291 133.222 76.9462 134.098 76.9462C134.975 76.9462 135.692 76.2291 135.692 75.3525V71.9419H139.103C139.979 71.9419 140.696 71.2247 140.696 70.3481C140.696 69.4716 139.979 68.7544 139.103 68.7544H139.087Z",
    fill: "#0078D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.625 99.7164C197.625 98.3098 197.986 97.327 198.716 96.7499C199.446 96.1728 200.339 95.8933 201.403 95.8933C202.467 95.8933 203.342 96.1818 204.072 96.7499C204.812 97.327 205.181 98.3098 205.181 99.7164C205.181 101.123 204.812 102.079 204.072 102.683C203.333 103.287 202.449 103.594 201.403 103.594C200.357 103.594 199.446 103.287 198.716 102.683C197.986 102.079 197.625 101.087 197.625 99.7164ZM203.711 91.4479H199.167L197.932 65.3438H204.947L203.711 91.4479Z",
    fill: "#0078D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.175 145.063C111.913 144.776 122.798 133.939 122.496 120.854C122.193 108.2 111.483 97.9997 98.175 97.7128C97.6491 97.7128 97.0753 97.665 96.5175 97.665H95.115C92.5332 84.5325 80.4366 75.0497 66.4116 75.1453C50.0916 75.4641 37.0388 88.1662 37.0866 103.705C37.0866 104.646 37.1503 105.57 37.2619 106.51C27.0938 107.785 19.5235 116.073 19.5872 125.827C19.4916 136.186 28.1138 144.728 38.9991 145.063H98.1591H98.175Z",
    stroke: "#737373",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0399 154.036L48.4502 155.677M38.8558 182.022L38.2661 183.648M45.9002 162.674L41.4058 175.01M94.6371 168.396L94.0474 170.021M99.7371 154.387L97.1871 161.383M91.4974 177.034L88.9474 184.046M68.5155 153.446L63.3517 166.706H73.6792L70.5395 175.121L67.8461 182.309M65.567 177.671L67.7664 182.676L72.8027 180.46",
    stroke: "#0078D7",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8794 229.5V239.493M92.8837 234.504H82.875",
    stroke: "#737373",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_795_1493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 255,
    height: 255,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicCloudStormDark255);
export default __webpack_public_path__ + "static/media/graphic_cloud-storm-dark-255.df61527a4f25f4f6dcfafa12bdb32740.svg";
export { ForwardRef as ReactComponent };